import React from "react";
import { prepCommonPageProvider } from "pages/commonPage";
import { Id, Env } from "core/utils";
import { showNav, hideFooter } from "pages/commonPage/Nav";
var CommonPageProvider = prepCommonPageProvider(Id.component.interactive);
export var prepRoute = function (controller) { return ({
    match: function (type) {
        return type === "Interactive";
    },
    page: function (_a) {
        var data = _a.data;
        var interactivePage = data;
        if (interactivePage.appUrl && interactivePage.appUrl.url) {
            if (Env.isClient) {
                window.location.replace(interactivePage.appUrl.url);
            }
            controller.setRedirectUrl(interactivePage.appUrl.url);
            return null;
        }
        return React.createElement(CommonPageProvider, { data: data });
    },
    showNav: showNav,
    hideFooter: hideFooter,
}); };
